/* eslint-disable */
import React, { memo, useEffect, useState } from "react";
import * as API from '../../framework/API/api'
import { Checkbox } from "@progress/kendo-react-inputs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { utility } from "../../framework/utility/utilityProvider";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, ROLETYPE, SEGMENT_DETAILS_CREDIT_TYPE, SUBTITLETYPE, TOAST_TYPES, TX_MODE, VERSION_TYPE, VODTYPE } from "../../framework/constant/constant";
import SegmentTypeCollectionTab from "./SegemnetTypeCollectionTab";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { CheckboxCell } from "../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell";
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import SaveRoundButton from "../../framework/forms/helpercomponents/buttons/SaveRoundButton";
import CancelRoundButton from "../../framework/forms/helpercomponents/buttons/CancelRoundButton";
import { useRef } from "react";
import { SegmentQC } from "./SegmentQC";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import RefreshButton from "../../framework/forms/helpercomponents/buttons/RefreshButton";
import MediaFastSegmentationPopup from "./MediaFastSegmentationPopup";
import { MenuCommandCell } from "../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";
import { collectionSegmentMenuModel } from "../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel";
import MediaEpisodeHistory from "../Planning/MediaEpisodeHistory";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import BossDialog from "../../components/BossDialog";
import { ConfirmAlert } from "../../ConfirmAlert";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { MediaMamAssetColumns } from "../../framework/utility/customColumns";
import { EnumCell } from "../../framework/forms/helpercomponents/CustomGridCells/EnumCell";
import { TransmissionTypeStatusCell } from "../../components/TransmissionTypeStatusCell";
import SegmentExtensionEditForm from "./SegmentExtensionEditForm";
import CreateTransmissionForm from "../../framework/OTT/CreateTransmissionForm";
import { TransmissionBrowser } from "../MediaLibrary/NodeTreeView/TransmissionBrowser";
import TransmissionReportForm from "../MediaLibrary/transmission/TransmissionReportForm";
import { DataHelper } from "../../framework/helper/DataHelper";
import { ContextMenu } from "primereact/contextmenu";
import ToastNotification from "../../components/ToastNotification";
import MediaEpisodeSubtitleForm from "./MediaEpisodeSubtitleForm";

function MediaEpisodeSegmentEditForm(props) {

  const { segmentData = [], metaData = {} } = props;

  const lang = useTranslation();
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

  const [segmentTypes, setSegmentTypes] = useState([]);
  const [mediaEpisodeSegments, setMediaEpisodeSegments] = useState(segmentData);
  const [segmentDetails, setSegmentDetails] = useState([]);
  const [editToggle, setEditToggle] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editItem, setEditItem] = useState([]);
  const [dialogTitle, setDialogTitle] = useState(lang.create_version_dialog_header);
  // const [language, setLanguage] = useState([]);
  const [channels, setChannels] = useState([]);
  const [materialContent, setManageContent] = useState([]);
  const [versions, setVersions] = useState([]);
  const [showMamAssetCollectionSelection, setShowMamAssetCollection] = useState(false);
  const [attachMAMInternal, setAttachMAMInternal] = useState(false);
  const [isAttachFromContextMenu, setIsAttachFromContextMenu] = useState(false);

  const fileRef = useRef(null);
  const [file, setFile] = useState('');

  const [selectedFile, setSelectedFile] = useState(lang.select_file_label);
  const [showQCStatus, setShowQCStatus] = useState(false);
  const [fastSegmentationPopupOpen, setFastSegmentationPopupOpen] = useState(false);
  const [showSegmentHistory, setShowSegmentHistory] = useState(false);
  const [showChannelGroups, setShowChannelGroups] = useState(false);
  const [showSegmentExtensionPopup, setShowSegmentExtensionPopup] = useState(false);
  const [transmissionReport, setTransmissionReport] = useState({ show: false, message: '', items: [] });
  const [filterVersionType, setFilterVersionType] = useState(null);
  const [showSegementDetailContextMenu, setShowSegementDetailContextMenu] = useState(false);
  const [showSubtitles, setShowSubtitles] = useState(false);

  const menuRef = useRef();


  const segmentQCRef = useRef();
  const setSegementQCRef = (data) => {
    segmentQCRef.current = data;
  }

  const segmentHistoryRef = useRef();
  const setSegementHistoryRef = (data) => {
    segmentHistoryRef.current = data;
  }

  const selectedItemRef = useRef({});
  const setSelectedItemRef = (data) => {
    selectedItemRef.current = data;
  }

  // company Data
  const companyData = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const user = utility.getValue(LOCALSTORAGE_KEY.userData);

  let initialValue = {
    ActualDuration: utility.convertMilisecondsToStringWithFrames(0),
    SegmentType: {},
    SegmentNumber: companyData?.segByRc ? props?.mediaEpisodeEntity?.ReferenceCode : props.mediaEpisodeEntity.AssetId,
    fileupload: "",
    SegmentDetails: [],
    IsHardParted: false,
    IsDefault: false,
    // Language: {},
    Subtitle: false,
    SubtitleType: {},
    TXReady: false,
    MaterialContent: {},
    Remarks: '',
    PgRating: {},
    Channels: [],
    // VersionCategory: {},
    TransmissionType: {},
    VersionType: VERSION_TYPE.Linear,
    Mam: {},
    SegmentExtension: {},
    Subtitles: []
  }

  const [dataItem, setData] = useState(initialValue);

  const dataItemRef = useRef(initialValue);
  const defaultSegmentType = useRef({});

  const [pgRatings, setPgRatings] = useState([]);
  const [selectAllChannels, setSelectAllChannels] = useState(false);
  const [showSegmentDetailsInFullScreen, setShowSegmentDetailsInFullScreen] = useState(false);
  const [showCreateTransmission, setShowCreateTransmission] = useState(false);
  const [showTransmissionBrowser, setShowTransmissionBrowser] = useState(false);
  const [transmissionTypes, setTransmissionTypes] = useState([]);
  const [filterTransmissionTypes, setFilterTransmissionTypes] = useState([]);

  const setDataItem = (data) => {
    dataItemRef.current = data;
    setData(data);
  }

  const MyCheckBoxCell = (props) => <CheckboxCell {...props} />;

  let segmentDetail = {
    Sequence: 0,
    MediaId: "",
    TcIn: '00:00:00:00',
    TcOut: '',
    Duration: '',
    IsPreviewed: false
  };

  useEffect(() => {
    loadCombo();
  }, [editToggle])

  useEffect(() => {
    if (props.mediaEpisodeEntity != undefined && props.mediaEpisodeEntity.SID > 0 && segmentData.length == 0) {
      loadSavedSegments();
    }
  }, [props.mediaEpisodeEntity])

  const onChange = async (e) => {

    if (e.target.name == "fileupload") {
      setFile(e.target.files[0]);
      setSelectedFile(lang.select_file_label);
      setDataItem({ ...dataItem, File: e.target.files[0].name });
    } else if (e.target.name == "MaterialContent") {
      //check 
      let value = e.target.value
      const updatedContent = await API.getAndSaveMaterialContentNextHouseNumber(value.SID, { ...value, isSaveNextnumber: false });
      if (!updatedContent.success) return;
      console.log(!updatedContent.success);
      setDataItem({ ...dataItem, MaterialContent: value, SegmentNumber: updatedContent.data.HouseNumber });

      let tempSegmentNumber = dataItem.SegmentNumber.length == 0 ? props.mediaEpisodeEntity.AssetId : dataItem.SegmentNumber;
      setSegmentDetails(segmentDetails.map((x) => {
        return {
          ...x,
          MediaId: x.MediaId.replace(
            tempSegmentNumber,
            updatedContent.data.HouseNumber
          )
        }
      }));

    } else if (e.target.name == 'GenerateMaterialID') {
      if (e.target.value) {
        setDataItem({ ...dataItem, SegmentNumber: '', [e.target.name]: e.target.value })
      } else {

        if (dataItem.MaterialContent == undefined || Object.keys(dataItem.MaterialContent).length == 0) {
          setDataItem({ ...dataItem, SegmentNumber: props.mediaEpisodeEntity.AssetId, [e.target.name]: e.target.value })
          return;
        }

        setDataItem({
          ...dataItem,
          SegmentNumber: props.mediaEpisodeEntity.AssetId,
          [e.target.name]: e.target.value,
          MaterialContent: {}
        });
        setSegmentDetails(segmentDetails.map((x) => {
          return {
            ...x,
            MediaId: x.MediaId.replace(dataItem.SegmentNumber, props.mediaEpisodeEntity.AssetId)
          }
        }));

      }
    } else if (e.target.name === "IsAllChannel") {
      const newValue = !selectAllChannels;

      setSelectAllChannels(newValue);

      setDataItem({
        ...dataItem,
        Channels: newValue ? channels : []
      });
    } else if (e.target.name === "Channels") {
      if (e.target.value.length === channels.length) {
        setSelectAllChannels(true);
      } else {
        setSelectAllChannels(false);
      }
      setDataItem({
        ...dataItem,
        Channels: e.target.value
      });
    } else if (e.target.name == "MamID") {
      // setDataItem({ ...dataItem, [e.target.name]: e.target.value });
      props.handleMetaData({ ...metaData, MamID: e.target.value })
    } else if (e.target.name == "VersionType") {
      if (e.target.value?._id === VERSION_TYPE.Linear) {
        const filteredLinearTransmissionTypes = transmissionTypes.filter((x) => x?.Name?.toLowerCase() === "linear");
        setFilterTransmissionTypes(filteredLinearTransmissionTypes);
        setDataItem({ ...dataItem, [e.target.name]: e.target.value._id, TransmissionType: filteredLinearTransmissionTypes.length > 0 ? filteredLinearTransmissionTypes[0] : {} });
      } else if (e.target.value?._id === VERSION_TYPE.NonLinear) {
        const filteredNonLinearTransmissionTypes = transmissionTypes.filter((x) => x?.Name?.toLowerCase() !== "linear");
        setFilterTransmissionTypes(filteredNonLinearTransmissionTypes);
        setDataItem({ ...dataItem, [e.target.name]: e.target.value._id, TransmissionType: filteredNonLinearTransmissionTypes.length > 0 ? filteredNonLinearTransmissionTypes.find((x) => x?.Name?.toLowerCase() === "svod") : {} });
      } else {
        setFilterTransmissionTypes(transmissionTypes);
        setDataItem({ ...dataItem, [e.target.name]: e.target.value._id, TransmissionType: {} });
      }
    } else if (e.target.name == "Mam") {

      //On Attaching/Detaching MAM Asset Set Media Id in Segment Details as well
      let segDetails = segmentDetails.map((x) => {
        return {
          ...x, MediaId : value && Object.keys(value).length > 0 ? e.target.value.AssetId : x.MediaId
        }
      });

      setSegmentDetails(segDetails);
      setDataItem({ ...dataItem, SegmentDetails : segDetails, [e.target.name]: e.target.value });

    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  }

  const onFilterChangeVersionType = (e) => {
    const value = e.target.value;
    setFilterVersionType(value?._id || null);
  }

  const loadCombo = async () => {

    // SEGMENT TYPE
    let segmentTypeRes = await API.getDataLookup(ENTITYNAME.SegmentType, { sort: { Description: 1 } });
    setSegmentTypes(segmentTypeRes.data);

    if (dataItemRef.current.SegmentType == undefined || dataItemRef.current.SegmentType._id == undefined) {
      defaultSegmentType.current = utility.getDefaultItem(segmentTypeRes.data);
      setDataItem({ ...dataItemRef.current, SegmentType: defaultSegmentType.current })
    }

    // SUBTITLE
    if (dataItem.Subtitle && file != '') {
      //NEED TO CHECK IT IS CRASHING
      // let res = await API.readFile(file);
      // console.log(res);
    }
    // LANGUAGES
    // let languageRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    // setLanguage(languageRes.data);
    // MATERIAL CONTENT
    let materialContentRes = await API.getData(ENTITYNAME.MaterialContent, { sort: { Description: 1 }, query: ["MediaCategory.SID", "=", props?.mediaEpisodeEntity?.MediaCategory?.SID] });
    setManageContent(materialContentRes.data);
    // PG Rating
    let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPgRatings(pgRatingRes.data);
    // Version 
    let versionRes = await API.getDataLookup(ENTITYNAME.Version, { sort: { Name: 1 } });
    setVersions(versionRes.data);
    // CHANNELS
    let channelRes = await API.getValidChannels();
    setChannels(channelRes.data);
    // TRANSMISSION TYPES
    const transmissionTypesRes = await API.getDataLookup(ENTITYNAME.TransmissionTypes);
    const transmissionTypeData = transmissionTypesRes?.data ?? [];
    setTransmissionTypes(transmissionTypeData);

    const isLinear = dataItem.VersionType === VERSION_TYPE.Linear;
    setFilterTransmissionTypes(transmissionTypesRes?.data?.filter(({ Name }) =>
      isLinear
        ? Name?.toLowerCase() === "linear"
        : Name?.toLowerCase() !== "linear"
    ));

    if (!editItem?._id && transmissionTypeData?.length > 0) {
      setDataItem({ ...dataItem, TransmissionType: isLinear ? transmissionTypeData?.find(t => t.Name?.toLowerCase() === "linear") : transmissionTypeData?.find(t => t.Name?.toLowerCase() === "svod") });
    } else {
      setDataItem({ ...dataItem, ...editItem });
    }
  }

  const loadSavedSegments = async () => {

    let res = await API.getData(ENTITYNAME.MediaEpisodeSegment, { query: ['MediaEpisodeSID', '=', parseInt(props.mediaEpisodeEntity.SID)] });
    console.log(res.data);
    if (res.success) {
      setMediaEpisodeSegments(() => res.data);
      props.getSegmentData(res.data);
    }
  }

  //to get data from collection on edit
  const onEdit = (object) => {
    setEditToggle(true);
    setEditItem(object);
    setDialogTitle(`${lang.edit_version_dialog_header}`);

    let castedSegmentDetail = object.SegmentDetails.map(item => ({
      ...item, TcIn: utility.convertMilisecondsToStringWithFrames(item.TcIn),
      TcOut: utility.convertMilisecondsToStringWithFrames(item.TcOut),
      Duration: utility.convertMilisecondsToStringWithFrames(item.Duration),
      Remarks: item?.Remarks ?? ''
    }));

    setSegmentDetails(() => castedSegmentDetail);

    setDataItem(prev => ({
      ...object, ["ActualDuration"]: utility.convertMilisecondsToStringWithFrames(object.ActualDuration),
      VersionType: object?.VersionType ?? VERSION_TYPE.Linear,
      TransmissionType: object?.TransmissionType && Object.keys(object?.TransmissionType).length > 0 ? object?.TransmissionType : prev?.TransmissionType
    }));
    setFile(object.File);
    setSelectAllChannels(object?.Channels && object?.Channels.length > 0 && object?.Channels?.length === channels?.length ? true : false);
    setEditMode(() => true);

  }

  const handleGenerateSegmentClick = async (e) => {

    e.preventDefault();

    if (dataItem.SegmentNumber == undefined || dataItem.SegmentNumber == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_material_id_error_message });
      return;
    }

    if (dataItem.GenerateMaterialID && (!dataItem.MaterialContent || Object.keys(dataItem.MaterialContent).length == 0)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Select Material Content first` });
      return;
    }

    generateSegment();

  }

  const onSaveSegments = async (saveSegmentData) => {

    // Save Segments
    const mediaEpisode = props?.mediaEpisodeEntity ?? {};
    let finalSegmentData = {
      ...saveSegmentData,
      MediaEpisodeSID: mediaEpisode?.SID,
      MediaEpisode_id: mediaEpisode?._id,
      MediaEpisode: mediaEpisode?._id ? {
        _id: mediaEpisode._id,
        Title: mediaEpisode.Title,
        AssetId: mediaEpisode.AssetId,
        EpisodeNumber: mediaEpisode.EpisodeNumber,
        EpisodeTitle: mediaEpisode.EpisodeTitle,
        Provider: mediaEpisode.Provider,
        MediaCategory: mediaEpisode.MediaCategory
      } : {},
      // MetaData: DataHelper.getMetaDataSegmentData(metaData),
      SegmentExtension: {
        workingTitle: mediaEpisode?.WorkingTitle,
        dealReference: mediaEpisode?.DealReference
      },
      Subtitles: dataItem.Subtitle ? dataItem.Subtitles : []
    }
    let res = await API.saveData(ENTITYNAME.MediaEpisodeSegment, finalSegmentData);
    // Auto Create MAM Asset and WO
    const isAutoCreateMAMAssetOnVersion = utility.isAutoCreateMAMAssetOnVersion();
    let mamAsset = res.data?.Mam ?? {};
    if (isAutoCreateMAMAssetOnVersion) {
      let mamAssetResponse = await API.createMamAndWorkOrderFromVersion({
        segmentId: saveSegmentData?._id ?? res?.data?._id,
        MediaEpisodeSID: props?.mediaEpisodeEntity?.SID,
      });
      console.log(mamAssetResponse);
      mamAsset = mamAssetResponse?.data ?? {};
    }
    let segmentIndex = mediaEpisodeSegments.findIndex(x => x._id === saveSegmentData._id);
    if (segmentIndex == -1) {
      setMediaEpisodeSegments(() => [...mediaEpisodeSegments, { ...saveSegmentData, ...res.data, Mam: mamAsset }]);
      props.getSegmentData([...mediaEpisodeSegments, { ...saveSegmentData, ...res.data, Mam: mamAsset }]);
    }
    // if formats are attached we need to make sure segment of same format type is created in system
    await API.updateSegmentInPlanning(props?.mediaEpisodeEntity?._id);
  }

  const onAddSegment = async (isNewSegment) => {

    if (isNewSegment) {
      let filtereddata = mediaEpisodeSegments.some((item) =>
        item.SegmentType?.SID == dataItem.SegmentType?.SID &&
        // item.Language?.SID == dataItem.Language?.SID &&
        item.SegmentType?.TXMode?.SID == dataItem.SegmentType?.TXMode?.SID);

      if (filtereddata) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${dataItem.SegmentType.Description} ${lang.version_label} ${lang.already_exists_global_error_message}` });
        return;
      }
    }

    // if (!dataItem.Channels || dataItem.Channels.length == 0) {
    // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
    //   return;
    // }

    if (!dataItem.VersionType) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_verison_type_error_message });
      return;
    }

    // isNewSegment true means new ,false means old edit
    if (!dataItem.SegmentType || segmentDetails.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_generate_segments_first_media_episode_version_error_message });
      return;
    }

    if (dataItem.SegmentType.SegmentCount != segmentDetails.length) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.generated_segments_selected_segmentType_mismatch_error_message });
      return;
    }

    if (dataItem.Subtitle) {
      // if (!dataItem.SubtitleType || Object.keys(dataItem.SubtitleType).length == 0) {
      //   ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_subtitle_type_error_message });
      //   return;
      // }
      // if (file == "" || file == undefined) {
      // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_file_error_message });
      //   return;
      // }
    }

    if (dataItem.GenerateMaterialID && (!dataItem.MaterialContent || Object.keys(dataItem.MaterialContent).length == 0)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_material_content_first_error_message });
      return;
    }

    // TransmissionType + IsDefault validation
    if (dataItem?.IsDefault === true && dataItem.VersionType != VERSION_TYPE.Linear && dataItem?.TransmissionType && Object.keys(dataItem.TransmissionType).length > 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.cannot_mark_default_for_segments_with_transmission_type_selected_error_message });
      return;
    }

    // Validation : IsHardParted changed after segment generation
    //COMMENTING NOW (12 Sep 2026 ) //NEED TO DISCUSS WITH TEAM
    // if (segmentDetails.length > 0) {

    //   const generatedWithHardParted = segmentDetails.some(x => x.MediaId !== dataItem.SegmentNumber);
    //   if (generatedWithHardParted !== dataItem.IsHardParted) {
    //     ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.is_hard_parted_has_been_changed_please_generated_segments_again_error_message });
    //     return;
    //   }
    // }
    //------------------------------------


    // if(checkExceedingSlotDuration()) {
    // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.exceeding_slot_duration_error_message });
    //   return;
    // }

    // if(checkOverlappingTimecodes()) {
    // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.overlapping_timecodes_error_message });
    //   return;
    // }

    // check dataItem.SegmentNumber != segmentDetails.MediaId
    // let duplicateMediaID = segmentDetails.some((item) => {
    //   let mediaId = item.MediaId.split('-');
    //   return mediaId[0] != dataItem.SegmentNumber
    // });

    // if (duplicateMediaID) {
    // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.material_id_and_media_id_mismatch_please_re_generate_segments_first_error_message });
    //   return;
    // }

    //CHECK SEGMENT TYPE and MEDIA ID
    let duplicateMaterialID = mediaEpisodeSegments.some((item) =>
      item._id != dataItem._id &&
      item.SegmentType?.SID == dataItem.SegmentType?.SID &&
      item.SegmentNumber == dataItem.SegmentNumber);

    if (!isAttachFromContextMenu && duplicateMaterialID) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.segment_already_exist_with_same_material_id_and_segment_type_error_message });
      return;
    }

    if (checkInvalidTimecodes()) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_duration_segment_error_message });
      return;
    }

    // If media episode not save yet
    if (!props?.mediaEpisodeEntity?._id) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_save_media_first_error_message });
      return;
    }

    segmentDetails.forEach((obj) => {
      delete obj.inEdit;
    })

    let materialID = dataItem.SegmentNumber;
    if (dataItem.GenerateMaterialID) {
      let id = await API.getAndSaveMaterialContentNextHouseNumber(dataItem.MaterialContent.SID, { ...dataItem.MaterialContent, isSaveNextnumber: true });
      materialID = id.data.HouseNumber
    }

    const saveSegmentData = {
      SID: dataItem?.SID ?? 0,
      SegmentType: dataItem?.SegmentType ? {
        _id: dataItem?.SegmentType?._id,
        SID: dataItem?.SegmentType?.SID,
        Description: dataItem?.SegmentType?.Description,
        Title: dataItem?.SegmentType?.Title,
        SegmentCount: dataItem?.SegmentType?.SegmentCount,
        TXMode: dataItem?.SegmentType?.TXMode ? {
          _id: dataItem?.SegmentType?.TXMode?._id,
          SID: dataItem?.SegmentType?.TXMode?.SID,
          Name: dataItem?.SegmentType?.TXMode?.Name
        } : {}
      } : {},
      Channels: dataItem?.Channels?.map((x) => {
        return { _id: x._id, SID: x.SID, FullChannelName: x.FullChannelName };
      }),
      ActualDuration: typeof dataItem.ActualDuration === 'string' ? utility.convertStringWithFramesToMilliseconds(dataItem.ActualDuration) : dataItem.ActualDuration,
      // Language: dataItem?.Language && Object.keys(dataItem?.Language)?.length > 0 ? {
      //   _id: dataItem?.Language?._id,
      //   SID: dataItem?.Language?.SID,
      //   Description: dataItem?.Language?.Description
      // } : {},
      SegmentNumber: materialID,
      VersionType: dataItem.VersionType,
      IsHardParted: dataItem?.IsHardParted ?? false,
      TXReady: dataItem?.TXReady ?? false,
      IsDefault: dataItem?.IsDefault ?? false,
      Archive: dataItem?.Archive ?? false,
      Subtitle: dataItem?.Subtitle ?? false,
      SubtitleType: dataItem?.Subtitle ? dataItem?.SubtitleType : {},
      File: dataItem?.Subtitle ? file?.name : "",
      Remarks: dataItem?.Remarks ? dataItem?.Remarks : "",
      SegmentDetails: segmentDetails.map(item => ({
        ...item, ["TcIn"]: typeof item.TcIn === 'string' ? utility.convertStringWithFramesToMilliseconds(item.TcIn) : item.TcIn,
        ["TcOut"]: typeof item.TcOut === 'string' ? utility.convertStringWithFramesToMilliseconds(item.TcOut) : item.TcOut,
        ["Duration"]: typeof item.Duration === 'string' ? utility.convertStringWithFramesToMilliseconds(item.Duration) : item.Duration,
        ["Remarks"]: item?.Remarks ?? ''
      })),
      PgRating: dataItem?.PgRating && Object.keys(dataItem?.PgRating)?.length > 0 ? {
        _id: dataItem.PgRating._id,
        Description: dataItem.PgRating.Description
      } : {},
      // VersionCategory: dataItem?.VersionCategory && Object.keys(dataItem?.VersionCategory)?.length > 0 ? {
      //   _id: dataItem?.VersionCategory?._id,
      //   Name: dataItem?.VersionCategory?.Name
      // } : {},
      TransmissionType: dataItem?.TransmissionType && Object.keys(dataItem?.TransmissionType).length > 0 ? {
        _id: dataItem?.TransmissionType?._id,
        SID: dataItem?.TransmissionType?.SID,
        Name: dataItem?.TransmissionType?.Name
      } : {},
      Subtitles: dataItem?.Subtitle ? dataItem?.Subtitles : [],
      Mam: dataItem?.Mam ? dataItem?.Mam : {}
    }

    const editIndex = mediaEpisodeSegments.indexOf(editItem)

    if (isNewSegment) {
      let temp = mediaEpisodeSegments;
      if (saveSegmentData.IsDefault) {
        temp = mediaEpisodeSegments.map((segment) => {
          return { ...segment, IsDefault: false }
        })
      }
      let saveData = [...temp, saveSegmentData]
      setMediaEpisodeSegments(() => saveData)
      props.getSegmentData(saveData);
    } else {

      let updatedSegments = mediaEpisodeSegments.map((data, index) => {
        if (editIndex == index) {
          saveSegmentData._id = editItem._id;
          saveSegmentData.SID = editItem.SID;
          return saveSegmentData
        } else {
          data.IsDefault = saveSegmentData.IsDefault ? false : data.IsDefault;
          return data;
        }
      })

      setMediaEpisodeSegments(() => updatedSegments);
      props.getSegmentData(updatedSegments);
    }

    props?.mediaEpisodeEntity?.SID > 0 && onSaveSegments(saveSegmentData);
    setDataItem(() => ({ ...initialValue, SegmentType: defaultSegmentType.current }));
    setSegmentDetails(() => []);
    setEditMode(false);
    setEditToggle(false);
  }

  const calculateSegmentDuration = function (episodeDuration, segmentCount) {

    const [hours, minutes, seconds, msec] = episodeDuration.split(':');
    // let frame = parseInt(msec)/40;
    let hoursToMilliseconds = parseInt(hours) * 3600000;
    let minutesToMilliseconds = parseInt(minutes) * 60000;
    let secondsToMilliseconds = parseInt(seconds) * 1000;

    let convertedMilliseconds = hoursToMilliseconds + minutesToMilliseconds + secondsToMilliseconds + (parseInt(msec) * 40);

    let result = segmentCount === 0 ? new Date('2000', '1', '1', '0', '0', '0') : utility.convertMilisecondsToStringWithFrames(convertedMilliseconds / segmentCount);
    return result;
  }

  const onAddSegmentQC = (dataItem) => {
    setShowQCStatus(true);
    setSegementQCRef(dataItem);
  }

  const onSegmentHistory = (dataItem) => {
    setSegementHistoryRef(dataItem);
    setShowSegmentHistory(true);
  }

  const onAttachMAMAsset = (item) => {
    setAttachMAMInternal(true);
    setShowMamAssetCollection(true);
    setDataItem(item);
    setEditItem(item);
    setIsAttachFromContextMenu(true);
    setSegmentDetails(item.SegmentDetails);

    console.log(item);
  }

  const onShowMAMAsset = (item) => {
    window.open(`/home/mamAssets?mamID=${item?.Mam?.AssetId}`, '_blank')
  }

  const onAddExtension = (item) => {
    setEditItem(item);
    setShowSegmentExtensionPopup(true);
  };

  const onCreateTransmission = (data = {}) => {
    setSelectedItemRef(data);
    setShowCreateTransmission(true);
  };

  const onShowTransmission = (data = {}) => {
    setSelectedItemRef(data);
    setShowTransmissionBrowser(true);
  };

  const onExportSegmentation = async (item) => {

    let payload = [{ _id: props.mediaEpisodeEntity._id, mediaCategorySID: props.mediaEpisodeEntity?.MediaCategory?.SID, Segment_id: item._id }];

    var res = await API.getSegmentationDataExport(payload);
    if (res.success) {
      if (res.dataLength == 0) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: "INFO", message: lang.no_data_found_for_selected_filter_error_message });
        return;
      }
      else {
        window.open(FILEURL().BASEURL + 'downloadReport/' + res.fileName)
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: "SUCCESS", message: 'Successfully Exported!' });
      }
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: "INVALID", message: res.message });
    }
  };

  const MyCommandCell = (props) => {
    const isValidChannel = utility.isValidSegmentChannelRights(props?.dataItem.Channels)
    return (
      isValidChannel ? <span></span> :
        <MenuCommandCell
          {...props}
          onEdit={onEdit}
          removeSegment={removeSegment}
          myMenuModel={collectionSegmentMenuModel}
          onAddSegmentQC={onAddSegmentQC}
          history={onSegmentHistory}
          attachMAM={onAttachMAMAsset}
          showMAM={onShowMAMAsset}
          addExtension={onAddExtension}
          onCreateTransmission={onCreateTransmission}
          onShowTransmission={onShowTransmission}
          onExport={onExportSegmentation}
        />
    )
  }

  const MyTimeCell = (props) => <TimeCell {...props} />;


  const removeSegment = async (dataItem) => {
    const index = mediaEpisodeSegments.indexOf(dataItem);

    if (dataItem._id != undefined) {
      let res = await API.deleteSegment({ segmentId: dataItem._id });
      if (!res.success) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        return;
      }
    }

    // removing from here UI
    setMediaEpisodeSegments(() => mediaEpisodeSegments.filter((data, Index) => {
      if (index != Index) {
        return data
      }
    }))

    // removing from main form save list of segments
    props.getSegmentData(mediaEpisodeSegments.filter((data, Index) => {
      if (index != Index) {
        return data
      }
    }));

    // if _id is not generated, means it is just created and not saved in db yet
    // we do not need to use it in delete loop on main save
    if (dataItem._id) {
      // props.handleDeletedSegments(dataItem);
    }
  }

  const generateSegment = function (e) {
    let segmentCount = dataItem.SegmentType.SegmentCount;
    let segmentTypeSuffix = dataItem.SegmentType.Suffix ? dataItem.SegmentType.Suffix : '';

    if (segmentCount) {

      if (props.mediaEpisodeEntity === null || props.mediaEpisodeEntity.Duration === null) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.media_episode_entity_duration_segment_error_message });
        return;
      }

      let segmentDetails = [];
      let episodeDuration = utility.convertMilisecondsToStringWithFrames(props.mediaEpisodeEntity.Duration);
      let actualSegmentDuration = calculateSegmentDuration(episodeDuration, segmentCount)  //to generate the function to calculate segment duration in utility folder

      let durationAsString = actualSegmentDuration;

      for (let cnt = 1; cnt <= segmentCount; cnt++) {

        if (dataItem.IsHardParted) {

          segmentDetail.Duration = actualSegmentDuration;
          segmentDetail.TcIn = '00:00:00:00';
          let millisecondsTcOut = utility.convertStringWithFramesToMilliseconds(segmentDetail.TcIn) + utility.convertStringWithFramesToMilliseconds(actualSegmentDuration);
          segmentDetail.TcOut = utility.convertMilisecondsToStringWithFrames(millisecondsTcOut);
          segmentDetail.IsPreviewed = false;

        } else {

          segmentDetail.Duration = actualSegmentDuration;
          segmentDetail.TcIn = segmentDetail.TcIn;
          let millisecondsTcOut = utility.convertStringWithFramesToMilliseconds(segmentDetail.TcIn) + utility.convertStringWithFramesToMilliseconds(actualSegmentDuration);
          segmentDetail.TcOut = utility.convertMilisecondsToStringWithFrames(millisecondsTcOut);
          segmentDetail.IsPreviewed = false;

        }

        let mediaId = !dataItem.IsHardParted ? dataItem.SegmentNumber : segmentTypeSuffix.length > 0 ?
          `${dataItem.SegmentNumber}-${segmentTypeSuffix}-${cnt}-${segmentCount}` :
          `${dataItem.SegmentNumber}-${cnt}-${segmentCount}`;

        if (company.Name && company.Name.toLowerCase() == "rotana") {
          mediaId = !dataItem.IsHardParted ? dataItem.SegmentNumber : segmentTypeSuffix.length > 0 ?
            `${dataItem.SegmentNumber}${segmentTypeSuffix}${cnt.toString().padStart(2, '0')}` :
            `${dataItem.SegmentNumber}${cnt.toString().padStart(2, '0')}`;
        }

        segmentDetails.push({
          Sequence: cnt,
          MediaId: mediaId,  //housenumber-segmentnumber-selectedsegmenttype.count === for mediaID
          TcIn: segmentDetail.TcIn,
          Duration: durationAsString,
          TcOut: segmentDetail.TcOut,
          IsPreviewed: false,
          Remarks: dataItem?.Remarks
        });
        segmentDetail.TcIn = segmentDetail.TcOut;


      }

      setSegmentDetails(segmentDetails);
      setDataItem({ ...dataItem, ["ActualDuration"]: episodeDuration });

    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_segment_type_media_episode_version_error_message });
    }

  }

  const updatedSegmentDetails = (updatedData) => {
    setSegmentDetails(updatedData);
  }

  const handleActualDuration = (durationAsString) => {
    dataItem.ActualDuration = durationAsString;
  }

  const clearData = () => {
    setSegmentDetails(() => []);
    setDataItem(() => ({
      ...initialValue,
      SegmentType: defaultSegmentType.current,
      Channels: user && user.Channels?.length == 1 ? channels : []
    }));
    setEditMode(false);
    setEditToggle(false);
    setSelectAllChannels(false);
    setEditItem({});
  }

  const openForm = () => {
    if (props.mediaEpisodeSID == 0) {
      setDataItem(() => ({ ...initialValue, SegmentType: defaultSegmentType.current }));
    }
    setEditToggle(!editToggle)
  }

  const onUpdateSegement = (item) => {
    let index = mediaEpisodeSegments.findIndex(x => x._id === item._id);
    var data = [...mediaEpisodeSegments];
    data[index] = item;
    setMediaEpisodeSegments(data);
    props.getSegmentData(data);
  }

  const refreshSegmentDetails = () => {
    var newData = segmentDetails.map((x, i) => {
      var item = {
        ...x,
        Sequence: i + 1,
        MediaId: `${dataItem.SegmentNumber}-${i + 1}-${dataItem.SegmentType.SegmentCount}`
      }
      delete item.inEdit;

      return item;
    })
    setSegmentDetails(newData);
  }

  const rowRender = (trElement, props) => {
    let trProps = {};
    let isValidChannel = utility.isValidSegmentChannelRights(props?.dataItem.Channels);
    if (isValidChannel) {
      trProps = {
        ...trProps,
        style: { backgroundColor: "#DDDDDD" }
      };
    }
    return React.cloneElement(trElement, trProps, trElement.props.children);
  };

  const onBrowseMamAsset = (datalist) => {
    console.log("BROWSE MAM");
    let name = attachMAMInternal ? "Mam" : "MamID";
    let value = datalist[0] && datalist[0].RawData && datalist[0].RawData.id ? datalist[0].RawData.id.toString() : datalist[0]?.AssetId;
    if (name == "Mam") { value = { _id: datalist[0]._id, CSID: datalist[0].CSID, AssetId: value } }
    onChange({ target: { name: name, value: value } });

    isAttachFromContextMenu && onAddSegment(false);

    if (company.Name && company.Name.toLowerCase() == "smg") {
      //SYNC MAM ASSET
      onSyncMAMAsset(datalist[0].RawData.id.toString());
    }
  }

  const onSyncMAMAsset = async (mamID) => {

    if (!mamID) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Not Mam ID found !!" });
      return;
    }

    const payload = {
      MamID: mamID,
      AssetId: props.mediaEpisodeEntity.AssetId
    }

    //CALL SYNC API HERE
    const reponse = await API.syncMediaManagement(payload)

    if (!reponse.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: reponse.message });
      return;
    }

    loadSavedSegments();
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: reponse.message });
  }

  const onDetachMAMAsset = (target) => {
    ConfirmAlert(
      () => onChange({ target: target }),
      () => { },
      lang.confirm_button_text,
      lang.detach_mam_asset_confirmation_msg
    );
  }

  const checkInvalidTimecodes = () => {
    if (segmentDetails.length === 0) return false;
    return segmentDetails.some(item => {
      let duration = item.Duration;
      return duration === null || duration === "00:00:00:00" || item.TcIn > item.TcOut;
    });
  }

  const checkExceedingSlotDuration = () => {
    if (segmentDetails.length === 0) return false;
    let isExceeding = props?.mediaEpisodeEntity?.Duration < utility.convertStringWithFramesToMilliseconds(dataItem.ActualDuration);
    return isExceeding;
  }

  const checkOverlappingTimecodes = () => {
    if (segmentDetails.length === 0) return false;

    return segmentDetails.some((currentItem, index) => {
      const nextItem = segmentDetails[index + 1];
      if (!nextItem) return false;

      const currentEnd = utility.convertStringWithFramesToMilliseconds(currentItem.TcOut);
      const nextStart = utility.convertStringWithFramesToMilliseconds(nextItem.TcIn);

      return currentEnd > nextStart && !dataItem?.IsHardParted;
    });
  };

  const handleChannelGroups = (groups = []) => {

    const linkedChannels = groups.flatMap(g => g.LinkedChannels || []);

    const uniqueChannels = Array.from(
      new Map(linkedChannels.map(ch => [ch._id, ch])).values()
    );

    setDataItem(prev => ({
      ...prev,
      Channels: uniqueChannels
    }));
    setSelectAllChannels(uniqueChannels.length === channels.length);

    setShowChannelGroups(false);
  };

  const mamHyperLinkCell = (props) => {
    const value = utility.getDataInsideObject(props.dataItem, props.field);
    return (
      <td>
        <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => window.open(`/home/mamAssets?mamID=${value}`, '_blank')}>
          {value}
        </div>
      </td>
    )
  }

  const onSaveCreateTransmission = async (data = {}) => {

    let transmissionData = {
      mediaSegments: [selectedItemRef.current],
      catalogue: {
        Catalogue: {
          _id: data.Catalogue._id,
          Description: data.Catalogue?.Description
        },
        ParentNodes: data.ParentNodes,
        Nodes: data.Nodes,
        Ott_Platforms: data.Ott_Platforms,
        TransmissionType: data.TransmissionType,
        AutoCreateNode: data?.AutoCreateNode ?? false
      }
    };

    let transmissionRes = await API.createTransmissionFromVersion(transmissionData);

    if (transmissionRes.success) {
      let data = transmissionRes.data || {};
      let cratedTransmission = data.cratedTransmission || [];
      let notCreatedTransmissionsArr = data.notCreatedTransmissions || [];

      utility.deleteLocalStorageItem(ENTITYNAME.Nodes);

      if (notCreatedTransmissionsArr.length > 0) {
        let reportItems = [
          ...cratedTransmission.map(item => ({ Title: item.Title, node: item.node, message: 'Created successfully', status: 'success' })),
          ...notCreatedTransmissionsArr.map(item => ({ Title: item.Title, node: item.node, message: item.message, status: 'failed' }))
        ];
        setTransmissionReport({
          show: true,
          message: transmissionRes.message || "Some transmissions were not created",
          items: reportItems,
          successCount: cratedTransmission.length,
          failedCount: notCreatedTransmissionsArr.length
        });
      } else {
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: transmissionRes.message || "All transmissions created successfully" });
      }
      // loaddata({ per_page: page_take, current_page: paramQuery.curPage }, wherestatement, andWhereStatement, '', false, filters);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: transmissionRes.message });
    }
    setShowCreateTransmission(false);
    setSelectedItemRef({});
  };

  const onSegmentDetailTypeChange = (type, clear = false) => {
    if (clear) {
      setSegmentDetails(
        segmentDetails.map(item => ({
          ...item,
          SegmentDetailType: undefined,
        }))
      );
      return;
    }

    if (segmentDetails.length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please add at least one segment before setting credit type" });
      return;
    }

    if (segmentDetails.length < 3) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Credits can be added for more than 2 segments" });
      return;
    }

    setSegmentDetails(
      segmentDetails.map((item, i) => {
        let SegmentDetailType = item.SegmentDetailType;

        // start -> keep existing + set first
        if (
          type === SEGMENT_DETAILS_CREDIT_TYPE.StartCredit &&
          i === 0
        ) {
          SegmentDetailType =
            SEGMENT_DETAILS_CREDIT_TYPE.StartCredit;
        }

        // end -> keep existing + set last
        if (
          type === SEGMENT_DETAILS_CREDIT_TYPE.EndCredit &&
          i === segmentDetails.length - 1
        ) {
          SegmentDetailType =
            SEGMENT_DETAILS_CREDIT_TYPE.EndCredit;
        }

        // both -> explicitly set both
        if (type === SEGMENT_DETAILS_CREDIT_TYPE.Both) {
          if (i === 0) {
            SegmentDetailType =
              SEGMENT_DETAILS_CREDIT_TYPE.StartCredit;
          }

          if (i === segmentDetails.length - 1) {
            SegmentDetailType =
              SEGMENT_DETAILS_CREDIT_TYPE.EndCredit;
          }
        }

        return {
          ...item,
          SegmentDetailType,
        };
      })
    );
  };

  const onCheckAllPreviewed = (previewed = false) => {
    const updatedData = segmentDetails.map(item => ({
      ...item,
      IsPreviewed: previewed,
    }));

    setSegmentDetails(updatedData);
  };

  const handleSubtiltes = (subs = []) => {
    setDataItem({ ...dataItem, Subtitle: true, Subtitles: subs })
  }

  const menuModel = [
    {
      label: "Set Start Credit",
      icon: 'fa fa-clock',
      command: () => onSegmentDetailTypeChange(SEGMENT_DETAILS_CREDIT_TYPE.StartCredit)
    },
    {
      label: "Set End Credit",
      icon: 'fa fa-clock',
      command: () => onSegmentDetailTypeChange(SEGMENT_DETAILS_CREDIT_TYPE.EndCredit)
    },
    {
      label: "Set Both Credit",
      icon: 'fa fa-clock',
      command: () => onSegmentDetailTypeChange(SEGMENT_DETAILS_CREDIT_TYPE.Both)
    },
    {
      label: "Clear Segment Detail Type",
      icon: 'fa fa-times',
      command: () => onSegmentDetailTypeChange(undefined, true)
    },
    {
      label: "Check All As Previewed",
      icon: 'fa fa-check-square',
      command: () => onCheckAllPreviewed(true)
    },
    {
      label: "Remove All As Previewed",
      icon: 'fa fa-minus-square',
      command: () => onCheckAllPreviewed()
    },
  ].filter(Boolean);


  const filteredSegments = filterVersionType ? mediaEpisodeSegments.filter((item) => item.VersionType === filterVersionType) : mediaEpisodeSegments;

  return (<>
    <div className="row form-box">

      <div className={'col-12'}>
        <div style={{ marginTop: "3px", display: "flex", justifyContent: "space-between" }}>
          <div style={{ marginTop: '5px' }}>
            <AddRoundButton onClick={() => setEditToggle(true)} />
            <RoundButton icon={"bolt"} title={"Fast Segmentation"} btnColor={'white'} onClick={() => setFastSegmentationPopupOpen(true)} />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

            {/* VERSION TYPE */}
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <label style={{ whiteSpace: "nowrap", marginBottom: 0 }}>
                {lang.version_type_label} :
              </label>
              <DropDownList
                style={{ width: "180px", backgroundColor: "white" }}
                data={[{ _id: null, Description: "All" }, ...Object.keys(VERSION_TYPE).map((key) => ({ _id: VERSION_TYPE[key], Description: key }))]}
                textField="Description"
                dataItemKey="_id"
                value={
                  [{ _id: null, Description: "All" }, ...Object.keys(VERSION_TYPE).map((key) => ({ _id: VERSION_TYPE[key], Description: key }))
                  ].find(x => x._id === filterVersionType) || { _id: null, Description: "All" }
                }
                onChange={onFilterChangeVersionType}
              />
            </div>

            {/* MAM ID */}
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <label style={{ whiteSpace: "nowrap", marginBottom: 0 }}>
                {lang.mamID_label} :
              </label>
              <button placeholder="Attach MAM Asset" title="Attach MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary"
                style={{ height: "30px" }} onClick={() => { setShowMamAssetCollection(true); setAttachMAMInternal(false); }}><i className="fa-solid fa-search fa-xs"></i>
              </button>
              {/* <button placeholder="Sync MAM Asset" title="Sync MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              style={{ height: "30px" }} onClick={onSyncMAMAsset}><i className="fa-solid fa-sync fa-xs"></i>
            </button> */}
              <button placeholder="Detach MAM Asset" title="Detach MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-error"
                style={{ height: "30px" }} onClick={() => { onDetachMAMAsset({ name: "MamID", value: '' }) }}><i className="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
        </div>
        <Grid rowRender={rowRender} data={filteredSegments} style={{ height: "53vh" }} resizable={true}>
          <GridColumn cell={MyCommandCell} width="55px" />
          <GridColumn field="SegmentType.Description" title={lang.segment_type_column} editable={false} width="150px" />
          <GridColumn field="SegmentType.TXMode.Name" title={lang.tx_mode_label} editable={false} width="150px" />
          <GridColumn field="Channels" title={lang.channel_label} editable={false} width="200px" cell={ArrayCell} format={"FullChannelName"} />
          <GridColumn field="VersionType" title={lang.version_type_label} width="150px" cell={EnumCell} />
          <GridColumn field="TransmissionType.Name" title={lang.transmission_type_column} cell={TransmissionTypeStatusCell} width="150px" />
          <GridColumn field="SegmentNumber" title={lang.material_id_column} editable={false} width="150px" />
          <GridColumn field="ActualDuration" title={lang.actual_duration_column} cell={MyTimeCell} editable={false} width="150px" />
          <GridColumn field="Mam.AssetId" title={lang.mam_id_column} cell={mamHyperLinkCell} editable={false} width="150px" />
          {/* <GridColumn field="VersionCategory.Name" title={lang.version_category_column} editable={false} width="150px" /> */}
          {/* <GridColumn field="Language.Description" title={lang.language_column} editable={false} width="150px" /> */}
          <GridColumn field="PgRating.Description" title={lang.pg_rating_column} editable={false} width="150px" />
          <GridColumn field="SegmentExtension.platforms" title={lang.platforms_column} cell={ArrayCell} format="Description" editable={false} width="250px" />
          <GridColumn field="SegmentExtension.videoFormat.Description" title={lang.video_format_column} editable={false} width="150px" />
          <GridColumn field="SegmentExtension.workingTitle" title={lang.working_title_column} editable={false} width="150px" />
          <GridColumn field="SegmentExtension.dealReference" title={lang.deal_reference_column} editable={false} width="150px" />
          <GridColumn field="IsDefault" title={lang.is_default_column} cell={MyCheckBoxCell} editable={false} width="150px" />
          <GridColumn field="Archive" title={lang.archive} cell={MyCheckBoxCell} editable={false} width="150px" />
          <GridColumn field="IsHardParted" title={lang.is_hard_parted_column} cell={MyCheckBoxCell} editable={false} width="150px" />
          <GridColumn field="TXReady" title={lang.transmission_column} cell={MyCheckBoxCell} editable={false} width="150px" />
        </Grid>
        <p className="mt-1">Note: {lang.segment_for_channel_rights_label}</p>
      </div>
      {editToggle && <BossDialog
        title={dialogTitle}
        onClose={clearData}
        width={'950px'}
      // height={'700px'}
      >
        <Form
          render={(formRenderProps) => (
            <FormElement>
              <div className="row">
                <div className="col-7" style={{ display: "flex" }}>
                  {!editMode && <AddRoundButton onClick={() => onAddSegment(true)} />}
                  {editMode && <SaveRoundButton onClick={() => onAddSegment(false)} />}
                  <CancelRoundButton onClick={clearData} />
                  <RefreshButton title={lang.refresh_generated_segments_tooltip} onClick={refreshSegmentDetails} />
                  {editMode && <RoundButton title={lang.add_extension_tooltip} onClick={() => setShowSegmentExtensionPopup(true)} icon="ellipsis-h" />}

                  <h6 style={{ fontWeight: 400, margin: '8px 0px 0px 5px' }}>{`REFERENCE CODE : ${props.mediaEpisodeEntity?.ReferenceCode ?? 'NA'}`}</h6>
                </div>
                <div className='col' style={{ textAlign: 'right' }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <label style={{ whiteSpace: "nowrap" }}>{lang.mamID_label} :</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="Mam"
                      value={dataItem.Mam?.AssetId ?? ''}
                      onChange={onChange}
                      disabled
                    />
                    <button placeholder="Attach MAM Asset" title="Attach MAM" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary"
                      style={{ height: "30px" }} onClick={() => { setShowMamAssetCollection(true); setAttachMAMInternal(true) }}><i className="fa-solid fa-search fa-xs"></i>
                    </button>
                    <button placeholder="Detach MAM Asset" title="Detach MAM" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-error"
                      style={{ height: "30px" }} onClick={() => { onDetachMAMAsset({ name: "Mam", value: {} }) }}><i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-1" style={{ border: "groove 1px" }}>
                <div className="row" style={{ margin: "5px" }}>
                  <div className="col-12 mt-1">
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="TabView">{lang.segment_type_label} *</label>
                          <DropDownList
                            style={{
                              backgroundColor: "white",
                            }}
                            data={segmentTypes}
                            name="SegmentType"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.SegmentType}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="TabView">{lang.tx_mode_label}</label>
                          <DropDownList
                            style={{
                              backgroundColor: "white",
                            }}
                            data={Object.keys(TX_MODE)}
                            name="TxMode"
                            value={dataItem?.SegmentType?.TXMode?.Name ?? utility.getKeyByValue(TX_MODE, TX_MODE.TX)}
                            onChange={onChange}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.material_id_label} *</label>
                          <input style={{ height: "32px" }}
                            type="text"
                            className="form-control form-control-sm"
                            name="SegmentNumber"
                            value={dataItem.SegmentNumber}
                            onChange={(e) => onChange(e)}
                            disabled={dataItem.GenerateMaterialID}
                            required
                          />
                        </div>
                      </div>
                      <div className="col form-group">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <label className="mb-0 fw-semibold">
                            {lang.channel_label}
                          </label>

                          <div className="d-flex align-items-center">
                            <span className="me-1">{lang.select_all_label}</span>
                            <input
                              type="checkbox"
                              name="IsAllChannel"
                              className="ml-1"
                              value={selectAllChannels}
                              checked={selectAllChannels}
                              onChange={(e) => onChange(e)}
                            />
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div style={{ flex: 1 }}>
                            <MultiSelect
                              data={channels}
                              name="Channels"
                              textField="FullChannelName"
                              dataItemKey="_id"
                              value={dataItem.Channels}
                              onChange={onChange}
                              style={{ maxHeight: "65px" }}
                            />
                          </div>
                          <button
                            type="button"
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                            style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginLeft: "6px" }}
                            title={lang.select_channel_groups_tooltip}
                            onClick={() => setShowChannelGroups(true)}
                          >
                            <i className="fa fa-ellipsis-h" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.version_type_label} *</label>
                          <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={Object.keys(VERSION_TYPE).map((key) => ({ _id: VERSION_TYPE[key], Description: key }))}
                            name="VersionType"
                            textField="Description"
                            dataItemKey="_id"
                            value={{ _id: dataItem.VersionType, Description: utility.getKeyByValue(VERSION_TYPE, dataItem.VersionType) }}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.transmission_type_label} </label>
                          <DropDownList
                            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                            data={filterTransmissionTypes}
                            name={"TransmissionType"}
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.TransmissionType}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      {/* <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.language_label}</label>
                          <DropDownList
                            style={{
                              backgroundColor: "white",
                            }}
                            data={language}
                            name="Language"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Language}
                            onChange={onChange}
                          />
                        </div>
                      </div> */}
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.remark_label}</label>
                          <input style={{ height: "32px" }}
                            type="text"
                            className="form-control form-control-sm"
                            name="Remarks"
                            value={dataItem.Remarks}
                            onChange={(e) => onChange(e)}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.pg_rating_label}</label>
                          <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={pgRatings}
                            name="PgRating"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.PgRating}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="">{lang.version_category_label}</label>
                          <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={versions}
                            name="VersionCategory"
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.VersionCategory}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                    </div> */}

                    {!editMode && <fieldset className="border rounded-4" style={{ padding: '20px 30px', margin: '8px 0px 0px 0px' }}  >
                      <div className="row">
                        <div className={dataItem.GenerateMaterialID ? "col-6" : 'col-12'} style={dataItem.GenerateMaterialID ? { marginTop: '19px' } : {}}>
                          <Field
                            style={{ borderColor: "black" }}
                            name={"GenerateMaterialID"}
                            component={Checkbox}
                            label={'Auto Generate Material ID'}
                            onChange={(e) => onChange(e)}
                            checked={dataItem.GenerateMaterialID}
                          />
                        </div>
                        {dataItem.GenerateMaterialID &&
                          <div className="col-6">
                            <label htmlFor="">{lang.material_content_sub_menu} *</label>
                            <DropDownList
                              style={{
                                backgroundColor: "white",
                              }}
                              data={materialContent}
                              name="MaterialContent"
                              textField="Description"
                              dataItemKey="SID"
                              value={dataItem.MaterialContent}
                              onChange={onChange}
                            />
                          </div>}
                      </div>
                    </fieldset>}

                    <div className="row mt-3 mb-2 align-items-center flex-nowrap">
                      <div className="col-auto">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"IsHardParted"}
                          component={Checkbox}
                          label={lang.is_hard_parted_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.IsHardParted}
                        />
                      </div>
                      <div className="col-auto">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"TXReady"}
                          component={Checkbox}
                          label={lang.transmission_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.TXReady}
                        />
                      </div>
                      <div className="col-auto">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"Archive"}
                          component={Checkbox}
                          label={lang.archive}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.Archive}
                        />
                      </div>
                      <div className="col-auto">
                        <Field
                          style={{ borderColor: "black" }}
                          name={"IsDefault"}
                          component={Checkbox}
                          label={lang.is_default_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.IsDefault}
                        />
                      </div>
                      <div className="col-auto d-flex align-items-center">
                        <Field
                          style={{ borderColor: "black" }}
                          name="Subtitle"
                          component={Checkbox}
                          label={`${lang.subtitle_label} ${dataItem.Subtitle ? `(${dataItem.Subtitles?.length ?? 0})` : ""}`}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.Subtitle}
                        />
                        {dataItem.Subtitle && (<RoundButton style={{ marginLeft: "5px" }} icon="ellipsis" onClick={() => setShowSubtitles(true)} title={`Add Subtitles\nCurrent Subtitles: ${dataItem.Subtitles?.length ?? 0}`} />)}
                        <ContextMenu
                          ref={menuRef}
                          model={menuModel}
                        />
                      </div>
                      <div className="col d-flex justify-content-end align-items-center" style={{ textAlign: "right" }} >
                        <ActionButton title={lang.generate_segments_button_text} name={lang.generate_segments_button_text} onClick={handleGenerateSegmentClick} />
                        <RoundButton style={{ marginLeft: "5px" }} icon="expand" title={lang.show_segment_details_full_screen_button_tooltip} onClick={() => setShowSegmentDetailsInFullScreen(!showSegmentDetailsInFullScreen)} />
                        <RoundButton style={{ marginLeft: "5px" }} icon="ellipsis" onClick={(e) => menuRef.current.show(e)} />
                      </div>
                    </div>

                    <div className="row mt-3" style={{ marginBottom: "05px" }}>
                      <div className="col-12">
                        {/* to add data list here */}
                        {showSegmentDetailsInFullScreen &&
                          <BossDialog title={lang.segment_details_label} onClose={() => setShowSegmentDetailsInFullScreen(!showSegmentDetailsInFullScreen)} width="80%">
                            <SegmentTypeCollectionTab
                              mediaDuration={props?.mediaEpisodeEntity?.Duration}
                              segmentDetails={segmentDetails}
                              updatedSegmentDetails={updatedSegmentDetails}
                              handleActualDuration={handleActualDuration}
                              generateSegment={generateSegment}
                              checkExceedingSlotDuration={checkExceedingSlotDuration}
                              checkOverlappingTimecodes={checkOverlappingTimecodes}
                              checkInvalidTimecodes={checkInvalidTimecodes}
                              showSegmentDetailsInFullScreen={showSegmentDetailsInFullScreen}
                            />
                          </BossDialog>}
                        <SegmentTypeCollectionTab
                          mediaDuration={props?.mediaEpisodeEntity?.Duration}
                          segmentDetails={segmentDetails}
                          updatedSegmentDetails={updatedSegmentDetails}
                          handleActualDuration={handleActualDuration}
                          generateSegment={generateSegment}
                          checkExceedingSlotDuration={checkExceedingSlotDuration}
                          checkOverlappingTimecodes={checkOverlappingTimecodes}
                          checkInvalidTimecodes={checkInvalidTimecodes}
                        />
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </FormElement>
          )} />

        {editMode && <h6 className="ml-3 mt-3">{lang.changes_Will_Reflect_in_new_planned_items_only_segmenttype_error_message}</h6>}
      </BossDialog>}
    </div >
    {showQCStatus && <SegmentQC segmentData={segmentQCRef.current} data={props.mediaEpisodeEntity} onClose={() => setShowQCStatus(false)} updateSegement={onUpdateSegement} />}

    {fastSegmentationPopupOpen && <MediaFastSegmentationPopup mediaEpisodeEntity={props.mediaEpisodeEntity} programScheduleEntity={{}} refreshSegments={loadSavedSegments} onClose={() => setFastSegmentationPopupOpen(false)} source={'media'} />}

    {showSegmentHistory && <MediaEpisodeHistory selectedData={props?.mediaEpisodeEntity} segment={segmentHistoryRef.current} closeForm={() => setShowSegmentHistory(false)} />}
    {showMamAssetCollectionSelection && <CollectionSelection entityname={ENTITYNAME.MediaMamAssets} customColumns={MediaMamAssetColumns} title={lang.attach_mam_asset_tooltip} closeForm={() => setShowMamAssetCollection(false)} wherestatement={props.wherestatement ?? ""} setDataList={onBrowseMamAsset} mode={"single"} width={"50vw"} />}
    {showChannelGroups && <CollectionSelection setDataList={handleChannelGroups} closeForm={() => setShowChannelGroups(false)} entityname={ENTITYNAME.ChannelGroups} width={"50vw"} title={lang.select_channel_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}
    {showSegmentExtensionPopup && <SegmentExtensionEditForm segmentId={editItem?._id} onCancel={() => setShowSegmentExtensionPopup(false)} />}
    {showCreateTransmission && <CreateTransmissionForm onSubmit={onSaveCreateTransmission} onClose={() => setShowCreateTransmission(false)} width={"25vw"} item={selectedItemRef.current} />}
    {showTransmissionBrowser &&
      <BossDialog
        title={lang.transmission_browser_header}
        onClose={() => setShowTransmissionBrowser(false)}
        width="70vw"
      >
        <TransmissionBrowser gridStyle={{ height: 'calc(100vh - 370px)' }} isFromMain={true} query={['mediaEpisodeSegment._id', '=', selectedItemRef.current?._id]} />
      </BossDialog >
    }
    {transmissionReport.show && <TransmissionReportForm onClose={() => setTransmissionReport({ show: false, message: '', items: [] })} transmissionReport={transmissionReport} />}
    {showSubtitles && <MediaEpisodeSubtitleForm data={dataItem.Subtitles} onClose={() => setShowSubtitles(false)} onSave={handleSubtiltes} />}
  </>)
}

export default memo(MediaEpisodeSegmentEditForm);